import { Component, Input, Output, EventEmitter } from '@angular/core';
import { GroupItem } from './group-item';
import { DossierTree } from './tree';


export interface GroupMovedEvent {
  item: GroupItem
  newOrder: number
}

@Component({
  selector: 't-dossier-tree',
  templateUrl: './dossier-tree.component.html',
})
export class DossierTreeComponent {
  @Input() tree: DossierTree

  @Output() selected = new EventEmitter();
  @Output() added = new EventEmitter();
  @Output() deleted = new EventEmitter();

  @Output() groupAdded = new EventEmitter();
  @Output() groupDeleted = new EventEmitter();
  @Output() groupDuplicated = new EventEmitter();
  @Output() groupMoved = new EventEmitter<GroupMovedEvent>();
}
